<template>
  <div id="pageFooter">
    <div class="page_foot_nav" :class="{'active': index === active}" v-for="(item, index) in routeList" :key="index" @click="footRoute(item.route)">
      <p :class="[item.iconfont, 'page_foot_iconfont', 'iconfont']"></p>
      <p class="page_foot_name">{{ item.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "pageFooter",
  data() {
    return {
      routeList: [
        {
          iconfont: "iconshouye",
          name: "首页",
          route: "/index"
        },
        {
          iconfont: "iconzichan",
          name: "资产",
          route: "/assets"
        },
        {
          iconfont: "iconwode",
          name: "我的",
          route: "/userCenter"
        }
      ],
      show: false,
      hide: true
    };
  },
  mounted () {
    this.show = true;
    setTimeout(() => {
      this.hide = false;
    }, 400);
  },
  methods: {
    footRoute(route) {
      this.$router.push({ path: route });
    }
  },
  props: ["active"]
};
</script>

<style lang="scss">
#pageFooter { 
  position: fixed;
  left: 0;
  bottom: 0;
  height: 98px;
  width: 750px;
  background: #fff;
  border-top: 1px solid #e5e5e5;
  .page_foot_nav {
    width: 33.33%;
    float: left;
    text-align: center;
    color: #b2b2b2;
    .page_foot_iconfont {
      font-size: 42px;
      line-height: 42px;
      padding-top: 15px;
    }
    .page_foot_name {
      font-size: 20px;
      line-height: 40px;
    }
    &.active {
      color: #29a1f7;
    }
  }
}
</style>
